<template>
    <div class="house-detail-rented">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <div class="tool-bar-mask"></div>
        <div class="house-detail-rented-head">
            <h1 class="page-title">{{houseDefault.name}}</h1>
            <div class="btn-group">
                <router-link :to="{ name: 'NewTask', query: { hid: $route.query.cid }}">
                    <button class="border-button save" >
                        <img src="@/assets/img/icon/plus_pink.svg" alt="">
                        委託
                    </button>
                </router-link>
                <button v-if="contractDetail.isPaperContract" @click="getContractPDF(contractCid)" class="default-button save" >查看合約</button>
                <button v-else class="default-button save" @click="getContract(contractCid)">查看合約</button>
                <!-- <dot-large-drop-menu>
                    <ul >
                        <router-link :to="{ name: 'NewTask', query: { hid: editHouse.houseCid }}">
                            <li>新增委託</li>
                        </router-link>
                        <li @click="modalStatus.deleteHouse = true">刪除房源</li>
                    </ul>
                </dot-large-drop-menu> -->
            </div>
        </div>
        <div class="user-info">
            <span class="title">租客</span>
            <span class="name">
                <img src="@/assets/img/icon/user_shot_black_small.svg" alt="">
                租客：
                {{contractDetail.tenant.tenantName}}
            </span>
        </div>
        <div class="house-detail-rented-body">
            <toogle-block titleMsg="房源說明">
                <div class="image-list">
                   <ul>
                       <li v-for="(image, index) in houseDefault.houseImageListList" :key="index">
                            <div class="preview">
                                <img :src="getImageUrl(image.imageUrl)" alt="">
                                <div v-if="index==0" class="cover-text">
                                    封面
                                </div>
                            </div>
                       </li>
                   </ul>
                </div>
                <div class="table-list house-description">
                    <div class="table-list-title">
                        <span class="description">房源介紹</span>
                        <span class="rent">房屋租金</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="description">{{houseDefault.description?houseDefault.description:''}}</span>
                            <span class="rent">$ {{houseDefault.rentMonthly?houseDefault.rentMonthly:''}}</span>
                        </div>
                    </div>
                </div>
            </toogle-block>
            <toogle-block titleMsg="房源類型">
                <div class="table-list house-info">
                    <div class="table-list-title">
                        <span class="rent-type">出租類型</span>
                        <span class="house-type">房屋類型</span>
                        <span class="house-elem">房源格局</span>
                        <span class="size">房源坪數</span>
                        <span class="country">房屋國籍</span>
                        <span class="special">特殊樓層</span>
                        <span class="floor">房源樓層</span>
                        <span class="shortest-period">最短租期</span>
                        <span class="is-with-landlord">與屋主同住</span>
                        <span class="move-in-date">最快起租日</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="rent-type">{{buildingType[houseDefault.buildingType-1].itemName}}</span>
                            <span class="house-type">{{houseType[houseDefault.houseType-1].itemName}}</span>
                            <span class="house-elem">{{getHouseElem}}</span>
                            <span class="size">{{houseDefault.size?houseDefault.size:0}}坪</span>
                            <span class="country">臺灣</span>
                            <span class="special">{{getSpecialType(houseDefault.specialType)}}</span>
                            <span class="floor">{{houseDefault.totalFloor}}樓</span>
                            <span class="shortest-period">{{houseDefault.shortestPeriod?houseDefault.shortestPeriod:0}}個月</span>
                            <span class="is-with-landlord">{{houseDefault.isWithLandlord?'是':'否'}}</span>
                            <span class="move-in-date">{{getFormatDate(houseDefault.moveInDate?houseDefault.moveInDate:'')}}</span>
                        </div> 
                    </div>
                </div>
                <div class="table-list house-address">
                    <div class="table-list-title">
                        <span class="address">房源地址</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="address">{{contractDetail.address}}</span>
                        </div>
                    </div>
                </div>
                <div class="table-list house-rent-include">
                    <div class="table-list-title">
                        <span class="rent-include">租金包含</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="rent-include">{{contractDetail.rentInclude}}</span>
                        </div>
                    </div>
                </div>
                <div class="table-list house-equipment">
                    <div class="table-list-title">
                        <span class="equipment">提供設備</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="equipment">{{contractDetail.equipment}}</span>
                        </div>
                    </div>
                </div>
                <div class="table-list house-rules">
                    <div class="table-list-title">
                        <span class="rule">使用規範</span>
                    </div>
                    <div class="table-list-body">
                        <div class="wrap">
                            <span class="rule">{{contractDetail.rules}}</span>
                        </div>
                    </div>
                </div>
            </toogle-block>
            <toogle-block titleMsg="房源政策">
                <div class="table-list house-policy">
                    <div class="table-list-title">
                        <span class="policy">自訂合約條款</span>
                    </div>
                    <div class="table-list-body">
                        <div class="policy-wrap">
                            <div class="policy" v-for="(policy, index) in contractDetail.policy" :key="index" >
                                {{policy}}
                            </div>
                        </div>
                    </div>
                </div>
            </toogle-block>
        </div>
    </div>
</template>
<script>
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import toogleBlock from '@/components/widge/toogleBlock.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'
import { 
    getHouseDetail
} from "@/apis/company/houseMgt.js"; 
import { 
    apiGetContractHouse,
    apiGetContractTenant
    } from "@/apis/api.js"; 
export default {
    data () {
        return {
            contractCid: null,
            contractDetail: {
                tenant: {},
                address: null,
                contractDetail: {},
                rentInclude: null,
                equipment: null,
                rules: null,
                policy: [],
                isPaperContract: null
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
            // tenant: {
            //     name: null
            // },
            // houseDescription: {
            //     images: [],
            //     description: null,
            //     rent: null,
            // },
            // houseType: {
            //     houseInfo: null,
            //     houseAddress: null,
            //     rentInclude: null,
            //     equipments: null,
            //     rules: null
            // },
            // housePolicy: {
            //     housePolicy: null
            // }
        }
    },
    mounted () {
        this.$store.dispatch('setHouseCid',  this.$route.query.cid)
        .then(() => {
            this.$store.dispatch('getEditHouseDefault')
        })
        this.getHouseInfo(this.$route.query.cid)
    },
    methods: {
        getHouseInfo: function (hid) {
            const data = {
                houseCid: hid,
                isLandlordWeb: true
            }
            getHouseDetail(data)
            .then( res => {
                console.log(res)
                if(res.data.status = 'SUCCESS'){
                    this.contractCid = res.data.result.houseDetail.contractCid
                    this.contractDetail.address = res.data.result.houseDetail.address
                    this.contractDetail.rentInclude = this.getHouseSetting(res.data.result.houseDetail.rentInclude)
                    this.contractDetail.equipment = this.getHouseSetting(res.data.result.houseDetail.equipment)
                    this.contractDetail.rules = this.getHouseSetting(res.data.result.houseDetail.rules)
                    this.contractDetail.policy = res.data.result.houseDetail.housePolicy
                    this.getContractDetail()
                    this.getContractTenant()
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getContractTenant: function () {
            let data = this.contractCid
            apiGetContractTenant(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.contractDetail.tenant = res.data.result
                }else{
                    this.alart.fail = true
                    this.msg.error = res.data.errorMsg
                    this.errorCode = res.data.errorCode
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContractDetail: function (){
            let data = this.contractCid
            apiGetContractHouse(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    this.contractDetail.isPaperContract = res.data.result.isPaperContract
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getContract: function (cid) {
            window.open('/contractPaper?cid='+cid, "_blank")
        },
        getContractPDF: function (cid) {
            apiGetContractPDF(cid)
            .then( res => {
                console.log(res)
                
                if(res.status == 200){
                //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getSpecialType: function (value) {
            let type = null
            this.specialType.map( item => {
                if(item.specialTypeCode == value){
                    type = item.itemName
                }
            })
            return type
        },
        getHouseSetting: function (arr) {
            let text = ''
            arr.map( (item, index) => {
                if(item.check == true){
                    text += item.itemName+ '、'
                }
            })
            return text.substring(0,text.length-1)
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        getImageUrl: function (url) {
            return constant.imageUrl+url
        }
    },
    computed: {
        getHouseElem: function () {
            let houseTypeVal = this.houseDefault.houseType-1
            let bedroom = 0
            let sharedRoom = 0
            let bathroom = 0
            let balcony = 0
            let hasBalcony = '無'
            let hasDuplex = '無'
            console.log(this.houseDefault.housePatternDto)
            if(this.houseDefault.housePatternDto){
                let bedroom = this.houseDefault.housePatternDto.bedroom
                let sharedRoom = this.houseDefault.housePatternDto.sharedRoom
                let bathroom = this.houseDefault.housePatternDto.bathroom
                let balcony = this.houseDefault.housePatternDto.balcony
            }
            if(this.houseDefault.roomPatternDto){
                let hasBalcony = this.houseDefault.roomPatternDto.hasBalcony?'有':'無'
                let hasDuplex = this.houseDefault.roomPatternDto.hasDuplex?'有':'無'
            }

            if(houseTypeVal == 0){
                return bedroom+'房 '+sharedRoom + '廳 '+bathroom+'衛浴 '+balcony+ '陽台'
            }else{
                
                return hasBalcony+'陽台 '+hasDuplex+'閣樓'
            }
        },
        ...mapGetters({
            houseRules: 'GET_EDIT_RULES',
            houseEquips: 'GET_EDIT_EQUIPS',
            houseRentInclude: 'GET_EDIT_RENT_INCLUDE',
            buildingType: 'GET_EDIT_BUILDING_TYPE',
            houseType: 'GET_EDIT_HOUSE_TYPE',
            specialType: 'GET_EDIT_SPECIAL_TYPE',
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
            houseDefault: 'GET_EDIT_HOUSE_DEFAULT',
            housePolicies: 'GET_EDIT_HOUSE_POLICY',
            despositPolicies: 'GET_EDIT_DESPOSIT_POLICY',
            complete: 'GET_EDIT_HOUSE_COMPELETE',
            publish: 'GET_EDIT_HOUSE_PUBLISH',
        })
    },
    components: {
        DotLargeDropMenu,
        toogleBlock,
        AlartMsg
    }
}
</script>
<style lang="scss" scoped>
    .house-detail-rented{
        .house-detail-rented-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            .btn-group{
                position: absolute;
                display: flex;
                align-items: center;
                top: -11px;
                right: 17px;
                .item-state{
                    margin-right: 24px;
                }
                .save{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 44px;
                    padding: 0;
                    width: 120px;
                    margin-right: 16px;
                    img{
                        margin-right: 5px;
                    }
                }
                .publish{
                    width: 104px;
                    margin-right: 16px;
                }
            }
            
        }
        .user-info{
            position: relative;
            width: 1154px;
            display: flex;
            align-items: center;
            height: 72px;
            margin-bottom: 60px;
            border-radius: 10px;
            background-color: #fff;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 76px;
                height: 100%;
                margin-right: 24px;
                color: #a8a5a4;
                border-right:1px solid #f1f5f4;
            }
            .name{
                display: flex;
                align-items: center;
                margin-right: 18px;
                img{
                    margin-right: 8px;
                }
            }
        }
        .house-detail-rented-body{
            .image-list{
                width: 1094px;
                height: 210px;
                border-radius: 8px;
                background: #fff;
                padding: 20px 30px;
                margin-bottom: 16px;
                ul{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: flex-start;
                    li{
                        margin-right: 14px;
                        margin-bottom: 20px;
                        .preview{
                            position: relative;
                            width: 124px;
                            height: 93px;
                            display: flex;
                            align-items: center;
                            border-radius: 4px;
                            overflow: hidden;
                            >img{
                                width: 100%;
                            }
                            .cover-text{
                                position: absolute;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 124px;
                                height: 30px;
                                bottom: 0;
                                border-bottom-left-radius: 4px;
                                border-bottom-right-radius: 4px;
                                background-color: #676362;
                                color: #fff;
                            }
                        }
                    }
                    li:nth-child(8){
                        margin-right: 0px;
                    }
                }
            }
            .table-list{
                .table-list-title{
                    padding: 24px 20px;
                }
                .table-list-body{
                    .wrap{
                        padding: 24px;
                        display: flex;
                        span{
                            display: flex;
                            align-content: center;
                        }
                    }
                    .policy-wrap{
                        padding: 24px;
                        >div{
                            margin-bottom: 16px;
                        }
                    }
                    .wrap.col{
                        flex-direction: column;
                        span{
                            margin-bottom: 16px;
                        }
                        span:last-child{
                            margin-bottom: 0px;
                        }
                    }
                }
            }
            .table-list.house-description{
                .description{
                    width: 476px;
                    margin-right: 60px;
                }
                
            }
            .table-list.house-info{
                .rent-type{
                    width: 56px;
                    margin-right: 51px;
                }
                .house-type{
                    width: 56px;
                    margin-right: 51px;
                }
                .house-elem{
                    width: 138px;
                    margin-right: 51px;
                }
                .size{
                    width: 58px;
                    margin-right: 40px;
                }
                .country{
                    width: 58px;
                    margin-right: 40px;
                }
                .special{
                    width: 58px;
                    margin-right: 40px;
                }
                .floor{
                    width: 58px;
                    margin-right: 40px;
                }
                .shortest-period{
                    width: 58px;
                    margin-right: 40px;
                }
                .is-with-landlord{
                    width: 80px;
                    margin-right: 20px;
                }
            }
            .table-list.house-info,
            .table-list.house-rent-include,
            .table-list.house-equipment,
            .table-list.house-address{
                margin-bottom: 16px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/HouseDetailRentedComp.vue